import React, { useState } from 'react';
import { Send, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { sendEmail } from '../services/emailService';

const PublishBook = () => {
  const [formData, setFormData] = useState({
    name: '',
    whatsapp: '',
    email: '',
    bookTitle: '',
    aboutBook: '',
    pages: '',
    bookSize: '',
    bookType: '',
    binding: '',
    address: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const result = await sendEmail(formData, 'publish');
    
    if (result.success) {
      alert(result.message);
      setFormData({
        name: '', whatsapp: '', email: '', bookTitle: '', aboutBook: '',
        pages: '', bookSize: '', bookType: '', binding: '', address: ''
      });
    } else {
      alert(result.message);
    }
  };

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/books" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#667eea', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Books</span>
        </Link>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <div style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              📚 BOOK PUBLISHING
            </div>
            <h1 style={{ color: '#2d3748', fontSize: '3rem', fontWeight: 700, marginBottom: '20px' }}>Publish Your Book</h1>
            <p style={{ color: '#718096', fontSize: '1.2rem' }}>
              Get a personalized quote for your book publishing needs. Fill out the form below and we'll contact you with pricing details.
            </p>
            <div style={{ marginTop: '16px', textAlign: 'center' }}>
              <p style={{ color: '#2d3748', fontSize: '1rem', fontWeight: 700, marginBottom: '8px' }}>This package details as pdf</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <a
                  href="/BOOK PUBLICATION.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: '#edf2ff',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    color: '#667eea',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  Individual Book Publication (PDF)
                </a>

                <a
                  href="/BOOK CHAPTER.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: '#edf2ff',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    color: '#667eea',
                    fontWeight: 600,
                    textDecoration: 'none'
                  }}
                >
                  Book Chapter Publication (PDF)
                </a>
              </div>
            </div>
          </div>

          <div style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
            padding: '3px', 
            borderRadius: '20px', 
            boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)' 
          }}>
            <div style={{ 
              backgroundColor: 'white', 
              padding: '50px', 
              borderRadius: '17px'
            }}>
              <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '25px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>👤 Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📱 WhatsApp Number *</label>
                    <input
                      type="tel"
                      name="whatsapp"
                      value={formData.whatsapp}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📧 Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📖 Book Title *</label>
                  <input
                    type="text"
                    name="bookTitle"
                    value={formData.bookTitle}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📝 About Book *</label>
                  <textarea
                    name="aboutBook"
                    value={formData.aboutBook}
                    onChange={handleInputChange}
                    required
                    rows={4}
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      resize: 'vertical',
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '25px' }}>
                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📄 No of Pages *</label>
                    <input
                      type="number"
                      name="pages"
                      value={formData.pages}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📏 Book Size *</label>
                    <select
                      name="bookSize"
                      value={formData.bookSize}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    >
                      <option value="">Select Size</option>
                      <option value="A4">A4 (8.27 x 11.69 inches)</option>
                      <option value="A5">A5 (5.83 x 8.27 inches)</option>
                      <option value="B5">B5 (6.93 x 9.84 inches)</option>
                      <option value="Custom">Custom Size</option>
                    </select>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '25px' }}>
                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📚 Type of Book *</label>
                    <select
                      name="bookType"
                      value={formData.bookType}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    >
                      <option value="">Select Type</option>
                      <option value="Individual">Individual</option>
                      <option value="Book Chapter">Book Chapter</option>
                    </select>
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>🔗 Binding *</label>
                    <select
                      name="binding"
                      value={formData.binding}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    >
                      <option value="">Select Binding</option>
                      <option value="Hard Bound">Hard Bound</option>
                      <option value="Soft Bound">Soft Bound</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>🏠 Address *</label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                    rows={3}
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      resize: 'vertical',
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                  <button type="submit" style={{
                    padding: '18px 50px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '30px',
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                  }}>
                    <Send size={20} />
                    Get Quote
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishBook;